<template>
  <div class="topDiv content item">
    <el-row class="rowHeight marginTop">
      <el-col :offset="1" :span="3" class="menuFontBig">
        <el-row>
          <el-col style="margin-left：24px;margin-top:32px">
            <el-image
              style="width: 50px; height: 50px"
              :src="goUrl(searchpeople)"
              fit="fill"
            ></el-image>
          </el-col>

          <!-- <el-col class="disabilityType">{{
            searchpeople.udTypesLabel
          }}</el-col>
          {{searchpeople}} -->
        </el-row>
      </el-col>
      <el-col :span="15" class="descFont">
        <el-row style="margin-top: 32px">
          <el-col>
            <span class="nameStyle">{{ searchpeople.udUsername }}</span>
            <span class="activityStatus">刚刚活跃</span>
          </el-col>
          <el-col class="marginTop">
            <span class="ageStyle">{{ searchpeople.udAge }}岁</span>
            <span style="margin: 0 10px">|</span>

            <span class="ageStyle">{{ searchpeople.udJobYears }}年</span>
            <span style="margin: 0 10px">|</span>

            <span class="ageStyle">{{ searchpeople.udEducationLabel }}</span>
            <span class="salary"
              >{{ !peomsg.qwMoneyS?0:peomsg.qwMoneyS }} - {{ !peomsg.qwMoneyE?0:peomsg.qwMoneyE }}</span
            >
          </el-col>
          <el-col class="marginTop">
            <span class="disabilityAera">优势：</span>
            <span
              class="levelStyle"
             
              >{{ searchpeople.udAdvantage == null?'无':searchpeople.udAdvantage.substring(0,40) }}</span
            >
          </el-col>
          <el-col class="marginTop">
            <span class="disabilityAera">学历：</span>
            <span class="levelStyle">{{
              searchpeople.udEducationLabel ==null?'无':searchpeople.udEducationLabel
            }}</span>
          </el-col>
          <el-col class="marginTop">
            <span class="disabilityAera">求职期望：</span>
            <span class="levelStyle">{{ peomsg.qwJob==null?'无':peomsg.qwJob  }}</span>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="5" class="descFont">
        <el-row>
          <el-col class="callme" @click.native="openJobs">打招呼</el-col>
          <el-col class="resumeStyle" style="margin-left: 0px"
            >简历完整度：{{ !searchpeople.udResumeIntegrity?0:searchpeople.udResumeIntegrity }}%</el-col>
        </el-row>
      </el-col>
    </el-row>

    <!-- class="artTitle marginTop" -->
    <el-dialog
      title="选择沟通职位"
      custom-class="ziZhidialog"
      :visible.sync="dialogVisible"
      width="750px"
    >
      <!-- <el-scrollbar style="height:400px;padding:0px 20px"> -->
      <div style="height: 400px; overflow-y: auto; padding: 0px 0px 0 20px">
        <JobViewIm
          style="margin-bottom: 15px"
          :item="item"
          v-for="item in jobs_arr"
          @click.native="openIM(item)"
        />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import JobViewIm from "@/components/company/JobViewIm.vue";
import { getAction, postAction, httpAction } from "@/comm/manage";
import Vue from "vue";
import { createIMToDisabled } from "@/comm/api";

export default {
  name: "",
  components: {
    JobViewIm,
  },
  data() {
    return {
      dialogFormVisible: false,
      dialogVisible: false,
      udDamagedArea:[],
      url: {
        update: "/interest/tsUserInterestPosition/add",
        addCompanyview: "/interest/tsUserInterestPosition/addCompanyview",
      },
      form: {
        desc: "",
      },
      personal: {
        avatar: require("@/assets/pcImage/company_default_logo2x.png"),
        salary: "3-4K",
      },
      jobs_arr: [],
      formLabelWidth: "120px",
      peomsg: {
        qwIndusty: null,
        qwJob: null,
        qwMoneyS: null,
        qwMoneyE: null,
        qwCity: null,
      },
    };
  },
  props: ["searchpeople"],
  created() {
    if (this.searchpeople && this.searchpeople.udHopepositiondata) {
      this.peomsg = JSON.parse(this.searchpeople.udHopepositiondata)[0];
    }
    if(this.searchpeople && this.searchpeople.udDamagedArea && this.searchpeople.udDamagedArea.indexOf(",")!=-1){
      this.udDamagedArea = this.searchpeople.udDamagedArea.split(",");
    }
  },
  methods: {
    goUrl(item) {
      return window._CONFIG["viewImg"] + item.udHeadPic;
    },
    changeClass(index) {
      this.menuIndex = index;
      //加载不同类型残疾人数据
    },
    openIM(item) {
      createIMToDisabled(item, this.searchpeople).then((res) => {
        this.dialogVisible = false;
        this.$store.commit("SET_CURRENTCIMITEM", this.searchpeople);
        this.$router.push({
          name: `pcCompanyChat`,
        });
      });
      let userInfo = this.$store.state.users.userInfo;

      if (userInfo.userType == "company") {
        let viewOver = {};
        viewOver.uipUdId = this.searchpeople.udId;
        viewOver.uipCpId = item.cpId;
        viewOver.uipComId = userInfo.ucComId;
        viewOver.uipType = "3";

        postAction(this.url.addCompanyview, viewOver).then((res) => {
          if (res.success) {
          } else {
          }
        });
      } else {
        return false;
      }
    },
    openJobs() {
      let userInfo = this.$store.state.users.userInfo;
      console.log(userInfo)
      if (userInfo) {
        let params = {
          comId: userInfo.ucComId,
          cpHrPhone: userInfo.ucPhone,
          pageSize: 100,
        };
        this.dialogVisible = false;
        getAction("/position/tsCompanyPosition/jobList", params).then((res) => {
          if (res.success) {
            this.jobs_arr = res.result;
            if(res.result && res.result.length > 0){
              this.dialogVisible = true;
            }else{
              this.$message.error("贵公司当前没有在招职位，请发布后再试！");
            }
            console.log(this.jobs_arr)
          } else {
            console.log("获取职位失败");
          }
        });
      } else {
        console.log("获取公司信息失败");
      }
      
    },
  },
};
</script>
<style lang="stylus" scoped>
.topDiv {
  font-size: 14px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);

  .marginTop {
    margin-top: 8px;
  }

  .callme {
    width: 88px;
    height: 32px;
    background: #f82b18;
    border-radius: 4px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    line-height: 32px;
    text-align: center;
    margin-top: 70px;
    cursor: pointer;
  }

  .resumeStyle {
    margin-top: 16px;
    font-size: 14px;
    font-weight: 400;
    color: #7c7c7c;
    line-height: 21px;
  }

  .rowHeight {
    margin-top: 12px;
    color: #9d9ea1;
  }

  .disabilityAera {
    font-size: 14px;
    color: #7c7c7c;
    font-weight: 550;
    line-height: 22px;
  }

  .ageStyle {
    font-size: 14px;
    font-weight: 400;
    color: #7c7c7c;
    line-height: 21px;
  }

  .levelStyle {
    font-size: 14px;
    font-weight: 400;
    color: rgba(0, 0, 0, 1);
    line-height: 22px;
  }

  .artTitle {
    font-size: 14px;
    line-height: 40px;
  }

  .nameStyle {
    font-size: 14px;
    font-weight: 550;
    color: rgba(51, 51, 51, 1);
    line-height: 21px;
  }

  .areaStyle {
    width: 50px;
    height: 20px;
    background: #e9f9fb;
    border-radius: 2px;
    font-size: 12px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #f82b18;
    line-height: 20px;
    padding: 0 5px;
    margin-right: 10px;
  }

  .activityStatus {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #cccccc;
    line-height: 22px;
    margin-left: 16px;
  }

  .salary {
    height: 20px;
    // background: #f82b18;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 400;
    // color: rgba(255, 255, 255, 1);
    line-height: 20px;
    text-align: center;
    margin-top: 74px;
    margin-left: 10px;
  }

  .disabilityType {
    height: 18px;
    border-radius: 8px;
    border: 1px solid #f82b18;
    font-size: 10px;
    font-weight: 400;
    color: #f82b18;
    line-height: 16px;
    text-align: center;
    margin-top: 10px;
    margin-left: -5px;
  }

  .menuFont {
    font-size: 14px;
    font-weight: 400;
    line-height: 40px;
    color: #000;
  }

  .menuFontBig {
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #000;
    line-height: 40px;
  }

  .descFont {
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
    line-height: 22px;
    padding-left: 10px;
  }

  .content {
    background: #fff;
    max-width: 556px;
    height: 210px;
    text-align: left;
  }
}

.item {
  background: rgba(247, 249, 252, 1);
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
}
</style>